import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { SignatureEffects, signatureReducer } from './store';

@NgModule({
  imports: [EffectsModule.forFeature([SignatureEffects]), StoreModule.forFeature(`signature`, signatureReducer)]
})
export class SignatureStateModule {}
